var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 105,
    viewBox: "0 0 289 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.845 86.8443L266.078 80.3511L262.94 86.6271L238.707 93.1203L241.845 86.8443Z",
    fill: "#EF0808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.157 74.0289L301.881 63.1167L296.607 73.6637L255.883 84.5756L261.157 74.0289Z",
    fill: "#E3E5F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.791 40.2455L257.665 33.0444L254.185 40.005L227.311 47.206L230.791 40.2455Z",
    fill: "#C3C6E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.959 96.1591L337.084 77.3691L335.205 81.1274L265.08 99.9174L266.959 96.1591Z",
    fill: "#051371"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.508 106.852L173.828 94.71L167.959 106.447L122.641 118.59L128.508 106.852Z",
    fill: "#051371"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.128 71.8009L278.867 45.3438L272.473 58.1305L173.734 84.5876L180.128 71.8009Z",
    fill: "#EF0808"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.787 15.9682L316.156 0.0615234L308.468 15.4369L249.1 31.3436L256.787 15.9682Z",
    fill: "#051371"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.341 59.7521L296.586 47.3608L295.347 49.8393L249.102 62.2305L250.341 59.7521Z",
    fill: "#051371"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.887 74.8902L187.132 62.499L185.892 64.9775L139.646 77.3687L140.887 74.8902Z",
    fill: "#C3C6E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoMobile);
export default __webpack_public_path__ + "static/media/deco-mobile.cff97bb6a081aef206b16d1b6981d1eb.svg";
export { ForwardRef as ReactComponent };